var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7333 14.6667V6.13333C31.7333 5.56754 31.5086 5.02492 31.1085 4.62484C30.7084 4.22476 30.1658 4 29.6 4H6.13333C5.56754 4 5.02492 4.22476 4.62484 4.62484C4.22476 5.02492 4 5.56754 4 6.13333V27.4667C4 28.0325 4.22476 28.5751 4.62484 28.9752C5.02492 29.3752 5.56754 29.6 6.13333 29.6H14.6667",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24.2667C13.4724 24.2667 14.6663 23.0728 14.6663 21.6C14.6663 20.1273 13.4724 18.9333 11.9997 18.9333C10.5269 18.9333 9.33301 20.1273 9.33301 21.6C9.33301 23.0728 10.5269 24.2667 11.9997 24.2667Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 21.5999V11.9373C14.667 11.4895 14.808 11.053 15.0699 10.6898C15.3318 10.3266 15.7013 10.055 16.1262 9.91346L22.5262 8.13568C22.8468 8.02888 23.1883 7.9998 23.5224 8.05082C23.8565 8.10184 24.1737 8.23151 24.4478 8.42914C24.722 8.62678 24.9453 8.88672 25.0993 9.18756C25.2533 9.48841 25.3336 9.82153 25.3337 10.1595V14.6665",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4669 36C32.1798 36 36.0003 32.1795 36.0003 27.4667C36.0003 22.7539 32.1798 18.9333 27.4669 18.9333C22.7541 18.9333 18.9336 22.7539 18.9336 27.4667C18.9336 32.1795 22.7541 36 27.4669 36Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7798 23.1518C25.3315 22.8978 24.8358 22.9848 24.4968 23.2481C24.1735 23.4993 24 23.8912 24 24.2952V30.7059C24 31.1095 24.1733 31.5021 24.4977 31.7534C24.8386 32.0174 25.3361 32.1019 25.7838 31.8449L31.3656 28.6396C31.3853 28.6282 31.4046 28.616 31.4233 28.6031C31.6031 28.4783 31.7486 28.3122 31.8484 28.1202C31.9483 27.9284 32 27.7157 32 27.5005C32 27.2853 31.9483 27.0727 31.8484 26.8808C31.7486 26.6889 31.6031 26.5228 31.4233 26.398C31.4047 26.385 31.3855 26.3729 31.3658 26.3616L25.7839 23.1542L25.7798 23.1518Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartLink);
export default __webpack_public_path__ + "static/media/smart-link.a84cce24.svg";
export { ForwardRef as ReactComponent };